module.exports = __webpack_public_path__ + "static/img/ranking_coin_2.718a8c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_coin_2.png
// module id = mz3L
// module chunks = 0